// define some constants for components
const commonStyle = {
    width: '100%',
    height: '100%',
};

export default commonStyle;
